import {
  formatPrice,
  hideRelatedSection,
  initializeRelatedSlider,
  updateRelatedContainers,
} from './relatedProductsHelper.js';

export const updateCartDrawerVehicleWidget = (vehicle) => {
  const vehicleWidget = document.getElementById('cm-ymm-cart-drawer');
  const cartDrawerEmpty = document.querySelector('#CartDrawer cart-drawer-items.is-empty');

  if (window.Convermax.isVehicleSelected() || vehicle || cartDrawerEmpty) {
    vehicleWidget.style.display = 'none';
    return;
  }

  vehicleWidget.style.display = 'block';
};

function initializeSlider(container) {
  const slider = container.querySelector('.cm_cart-related-products_items');
  const previousButton = container.querySelector('[data-cm-related-previous]');
  const nextButton = container.querySelector('[data-cm-related-next]');
  const scrollbar = container.querySelector('.cm_cart-related-products_scrollbar');
  const scrollbarThumb = scrollbar?.firstElementChild;

  if (!slider || !previousButton || !nextButton || !scrollbarThumb) {
    return;
  }

  initializeRelatedSlider(slider, previousButton, nextButton, scrollbarThumb);
}

function updateCartDrawerRelatedSection(items, container) {
  updateCartDrawerVehicleWidget();
  const controlsContainer = container.querySelector('.carousel-buttons');

  if (items.length === 0 || document.querySelector('#CartDrawer cart-drawer-items.is-empty')) {
    controlsContainer?.replaceChildren();
    hideRelatedSection(container);
    return;
  }

  const currentSlider = container.querySelector('slideshow-component, .cm_cart-related-products');
  if (!currentSlider) {
    return;
  }

  const sectionKey = container.id || 'related';
  const hasMultipleItems = items.length > 1;
  container.style.display = 'block';
  if (controlsContainer) {
    controlsContainer.innerHTML = hasMultipleItems
      ? `
          <div class="cm_cart-related-products_controls">
            <button type="button" data-cm-related-previous aria-label="Previous related product">‹</button>
            <button type="button" data-cm-related-next aria-label="Next related product">›</button>
          </div>
        `
      : '';
  }
  currentSlider.outerHTML = `
    <div class="cm_cart-related-products">
      <div class="cm_cart-related-products_items" role="list">
        ${items.map((item, index) => getProductCard(item, index, sectionKey)).join('')}
      </div>
      ${
        hasMultipleItems
          ? `
            <div
              class="cm_cart-related-products_scrollbar"
              style="--items-count: ${items.length}"
              aria-hidden="true"
            >
              <span></span>
            </div>
          `
          : ''
      }
    </div>
  `;

  if (hasMultipleItems) {
    initializeSlider(container);
  }
}

function getProductCard(product, index, sectionKey = 'related') {
  const uniqueKey = `${sectionKey}-${product.id}-${index}`;

  return `
    <div
      id="Slide--${uniqueKey}"
      class="cm_cart-related-products_slide complementary-slide complementary-slide--card grid__item"
      role="listitem"
    >
      <product-card class="block card-wrapper product-card-wrapper">
        <div
          class="product-card card card--card card--shape-adapt card--text-left card--media color-scheme-2 gradient card--horizontal border"
          style="--ratio-percent: 66.66666666666666%"
          data-product-handle="${product.handle}"
          data-product-vendor="${product.vendor}"
        >
          <div class="card__inner" style="--ratio-percent: 66.66666666666666%">
            <div class="card__media">
              <div class="media media--transparent">
                <img
                  class="card__image motion-reduce object-center object-contain"
                  src="${product.image}"
                  alt="${product.title}"
                />
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading text-body t3 font-bold" id="title-cart-drawer-${uniqueKey}">
                <a
                  href="${product.url}"
                  id="CardLink-cart-drawer-${uniqueKey}"
                  class="full-unstyled-link uppercase"
                >
                  ${product.title}
                </a>
              </h3>
              <div class="card-information">
                <div class="price t2 uppercase">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span class="price-item price-item--regular">${formatPrice(product.price)}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="39"
                        height="29"
                        viewBox="0 0 39 29"
                        fill="none"
                      >
                        <path
                          d="M20.6507 21.2051C21.3945 19.772 21.4995 19.3456 21.1645 19.1162C21.0245 19.0208 18.3557 18.9799 12.1332 18.9811C3.30198 18.9836 3.30198 18.9836 2.51198 18.6117C0.520728 17.6745 -0.569272 14.7898 0.304478 12.7728C0.614478 12.0563 2.07448 10.3542 2.66573 10.017C2.85948 9.90671 5.40698 9.85217 12.587 9.8063C21.4632 9.74927 22.2532 9.72696 22.3232 9.53729C22.3732 9.39969 22.0732 8.86663 21.4357 7.96167C18.9107 4.37779 19.162 1.89349 22.1995 0.42076C24.637 -0.760645 26.3982 0.343901 31.6295 6.33522C34.992 10.1856 35.842 11.1315 37.2707 12.6154C39.0095 14.4203 39.012 14.2728 37.2157 16.1869C36.447 17.0075 35.2795 18.2894 34.622 19.0356C31.9957 22.017 31.0532 23.0596 29.952 24.1976C29.3195 24.8509 28.2707 25.958 27.622 26.6571C26.9107 27.4232 26.1595 28.0939 25.7282 28.3493C25.0545 28.7484 24.9482 28.7732 23.877 28.7732C22.7395 28.7732 22.7395 28.7732 21.8445 28.203C19.5157 26.7203 19.0882 24.2137 20.6507 21.2051Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div data-cm-related-fitment aria-live="polite"></div>
              </div>
            </div>
          </div>
        </div>
      </product-card>
      <div class="cm_cart-related-products_quick-view quick-add no-js-hidden">
        <quick-add-modal
          id="QuickAdd-${uniqueKey}"
          class="popup-modal quick-add-modal popup-modal--small popup-modal--side hidden-during-load cm_cart-related-products_quick-add"
        >
          <div
            role="dialog"
            aria-label="Choose options for ${product.title}"
            aria-modal="true"
            class="popup-modal__content quick-add-modal__content custom-scrollbar global-settings-popup"
            tabindex="-1"
          >
            <button
              id="ModalClose-${uniqueKey}"
              type="button"
              class="quick-add-modal__toggle tap-target button-control"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                class="icon icon-close"
                viewBox="0 0 512 512"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="32"
                  d="M368 368L144 144M368 144L144 368"
                ></path>
              </svg>
            </button>
            <div id="QuickAddInfo-${uniqueKey}" class="quick-add-modal__content-info custom-scrollbar"></div>
          </div>
        </quick-add-modal>
        <modal-opener class="cm_cart-related-products_quick-view-opener" data-modal="#QuickAdd-${uniqueKey}">
          <button
            id="quick-add-cart-drawer-${uniqueKey}-submit"
            type="submit"
            name="add"
            class="cm_cart-related-products_quick-view-button quick-add__submit button button--secondary card--horizontal__quick-add tap-target animate-arrow"
            aria-haspopup="dialog"
            aria-live="polite"
            title="Add to cart"
            aria-labelledby="quick-add-cart-drawer-${uniqueKey}-submit title-cart-drawer-${uniqueKey}"
            data-product-url="${product.url}"
          >
            <span>
              Quick view
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="22" viewBox="0 0 28 22" fill="none">
                <path
                  d="M16.1204 15.5882C17.6815 14.0693 18.0839 14.1579 9.42138 14.1196C1.92608 14.0873 1.92608 14.0873 1.23854 13.4895C0.1885 12.5767 0 12.173 0 10.8241C0 9.39861 0.198167 8.97814 1.29171 8.09288C2.09887 7.43882 2.09888 7.43882 9.64612 7.43882C18.125 7.43882 17.7154 7.50591 16.617 6.3008C16.3765 6.03726 15.8702 5.40356 15.4908 4.89325C13.4922 2.19674 15.8944 -1.12029 18.7666 0.369916C19.4179 0.707728 20.8619 2.18476 22.5958 4.28591C22.829 4.56861 23.5963 5.43351 24.302 6.20856C28.1095 10.3917 28.2303 10.6169 27.3289 11.8472C26.7017 12.7049 25.8293 13.7279 23.9854 15.7643C21.6412 18.3542 21.2763 18.7771 20.9767 19.2599C20.6033 19.8588 19.4179 20.8794 18.647 21.2664C18.1721 21.5048 17.8531 21.5742 17.2332 21.5742C16.4466 21.5742 16.4225 21.5647 15.811 21.0052C14.1955 19.527 14.3212 17.3396 16.1204 15.5882Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="loading__spinner hidden">
              <svg
                aria-hidden="true"
                focusable="false"
                class="spinner"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </span>
          </button>
        </modal-opener>
      </div>
    </div>
  `;
}

export const updateCartDrawerRelatedProducts = (vehicle) => {
  const relatedRequiredProducts = document.querySelector('cart-drawer .cm_related-required');
  const relatedAccessoriesProducts = document.querySelector('cart-drawer .cm_related-accessories');

  const productIds = [...document.querySelectorAll('#CartDrawer cart-drawer-items tr')]
    .map((row) => row.dataset.productId)
    .filter(Boolean);

  updateRelatedContainers({
    relatedRequiredProducts,
    relatedAccessoriesProducts,
    productIds,
    vehicle,
    updateSection: updateCartDrawerRelatedSection,
    hideSection: hideRelatedSection,
  });
};

function refreshCartDrawer() {
  updateCartDrawerRelatedProducts();
  updateCartDrawerVehicleWidget();
}

export const addCartDrawerEventListeners = () => {
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('#cart-icon-bubble')) {
      refreshCartDrawer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.code.toUpperCase() === 'SPACE' && event.target.closest?.('#cart-icon-bubble')) {
      refreshCartDrawer();
    }
  });

  ['cart-add', 'cart-update', 'cart-remove'].forEach((eventName) => {
    document.addEventListener(eventName, () => {
      setTimeout(refreshCartDrawer, 100);
    });
  });

  document.body.addEventListener('modalClosed', () => {
    setTimeout(() => {
      updateCartDrawerRelatedProducts();
    }, 200);
  });
};
